import type { CategoryLink, ItemLink } from "@ext/navigation/NavigationLinks";

export const isGroupNode = (link: ItemLink | undefined): link is CategoryLink => !!link?.options?.grouping;
